import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { publicIdSchema } from "./public-id";
import { visitContentQuerySchema } from "./visit-content";

export const privateTemplateSchema = z.object({
  public_id: publicIdSchema,
  name: z.string(),
  headers: z.array(z.string()),
  optionalText: z.string().nullable(),
  isDefault: z.boolean(),
  createdAt: z.string(),
});
// kind=dictation lists only dictation templates (see dictation-report.ts);
// without it, the list has note templates only.
export const templateListQuerySchema = visitContentQuerySchema.extend({
  kind: z.enum(["note", "dictation"]).default("note"),
});
export type TemplateListQuery = z.output<typeof templateListQuerySchema>;
export const privateTemplateListSchema = z.object({
  items: z.array(privateTemplateSchema),
  nextCursor: publicIdSchema.nullable(),
});
const read = oc.errors({
  BAD_REQUEST: { message: "Invalid request" },
  NOT_FOUND: { message: "Not Found" },
  METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
  INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
  UNAUTHORIZED: { message: "Authentication required" },
  FORBIDDEN: { message: "Account required" },
  SERVICE_UNAVAILABLE: { message: "Authentication unavailable" },
});
export const templateReadContract = {
  listTemplates: read
    .input(
      z.object({
        query: templateListQuerySchema.default({ limit: 50, kind: "note" }),
        body: z.undefined().optional(),
      }),
    )
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/templates",
        inputStructure: "detailed",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(privateTemplateListSchema),
  getTemplate: read
    .input(
      z.object({
        params: z.strictObject({
          public_id: publicIdSchema,
        }),
        query: z.strictObject({}).default({}),
        body: z.undefined().optional(),
      }),
    )
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/templates/{public_id}",
        inputStructure: "detailed",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(privateTemplateSchema),
};
